import micromodal from 'micromodal';

let activeVideoPlayer = null;

function initVideoModals() {
    let videoModalBtns = document.querySelectorAll('.video-modal-button');

    videoModalBtns.forEach(modalBtn => {
        modalBtn.addEventListener('click', () => {
            let videoId = modalBtn.dataset.videoId;
            document.querySelector('.video-modal .video-embed').setAttribute('data-video-id', videoId);

            micromodal.show('video-modal', {
                onShow: modal => {
                    let embedContainer = modal.querySelector('.video-embed');

                    if (activeVideoPlayer) {
                        activeVideoPlayer.cueVideoById(embedContainer.dataset.videoId);
                        activeVideoPlayer.playVideo();
                    } else {
                        initVideoPlayer(embedContainer);
                    }
                },
                onClose: modal => {
                    let video = modal.querySelector('#video-player');
                    video.contentWindow.postMessage('{"event":"command", "func":"stopVideo", "args":""}', '*');
                },
                openTrigger: 'data-videomodal-trigger',
                closeTrigger: 'data-videomodal-close',
                disableScroll: true, // [6]
                disableFocus: true,
            });
        });

        /* Initialize video player */
        function initVideoPlayer(embedContainer) {
            if (document.getElementById('iframe_api') === null) {
                let tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                tag.id = "iframe_api";
                let firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            window.onYouTubeIframeAPIReady = function () {
                createVideoPlayer(embedContainer);
            }

            if (document.querySelector('.front-page-video-modal')) {
                createVideoPlayer(embedContainer);
            }
        }

        function createVideoPlayer(embedContainer) {
            let player = new YT.Player(embedContainer.id, {
                height: '100%',
                width: '100%',
                videoId: embedContainer.dataset.videoId,
                playerVars: {
                    autoplay: 1,
                    enablejsapi: 1,
                    rel: 0,
                    origin: window.location.origin,
                },
                events: {
                    'onReady': function (event) {
                        activeVideoPlayer = event.target;
                    },
                    'onStateChange': function (event) {
                        if (event.data === YT.PlayerState.CUED) {
                            YT.autoplay;

                        }
                    }
                }
            });
        }
    });
}

export { initVideoModals };